import { HcoTabIndex } from '@/pages/HCOOverview/tabs/tabsConstants';
import { AppRoutes } from '@/utils';
import { useMemo } from 'react';
import { matchPath } from 'react-router-dom';

export const EXCLUDE_HCP_SELECTION_ROUTES: string[] = [
  AppRoutes.HCP_OVERVIEW,
  AppRoutes.HCP_CLINICAL_TRIAL_DETAILS,
  AppRoutes.SEARCH_HCPS,
  AppRoutes.HCP_CONFERENCE_ABSTRACT_DETAILS,
  AppRoutes.CONFERENCE_ONE_PAGER,
];

export const EXCLUDE_FILTER_COMPONENT_ROUTES: string[] = [
  AppRoutes.HCP_OVERVIEW,
  AppRoutes.HCP_CLINICAL_TRIAL_DETAILS,
  AppRoutes.SEARCH_HCPS,
  AppRoutes.HCP_CONFERENCE_ABSTRACT_DETAILS,
  AppRoutes.DATA_REFRESH_DETAILS,
];

export const EXCLUDE_DATE_RANGE_ROUTES: string[] = [
  AppRoutes.COMPETITOR_ANALYSIS,
  AppRoutes.COMPETITOR_CSATSCORE,
  AppRoutes.COMPETITOR_CESSCORE,
  AppRoutes.COMPETITOR_NPSSCORE,
  AppRoutes.MY_HCPS,
  AppRoutes.CUSTOMER_FOCUS,
  AppRoutes.HCP_OVERVIEW,
  AppRoutes.HCP_CLINICAL_TRIAL_DETAILS,
  AppRoutes.SEARCH_HCPS,
  AppRoutes.PERSONALIZED_ENGAGEMENT,
  AppRoutes.HCP_CONFERENCE_ABSTRACT_DETAILS,
  AppRoutes.AGGREGATED_CONSENT_GROUP,
  AppRoutes.PARTNERSCORE,
  AppRoutes.CESSCORE,
  AppRoutes.CSATSCORE,
  AppRoutes.NPSSCORE,
  AppRoutes.DATA_REFRESH_DETAILS,
  AppRoutes.CONFERENCE_ONE_PAGER,
  AppRoutes.SALES_GROUP,
  AppRoutes.SALES_KEY_INDICATORS,
  AppRoutes.SALES_REGIONAL_FOCUS,
  AppRoutes.SALES_COMPETITOR_FOCUS,
];

export const isPathExcluded = (excludedRoutes: string[], pathname: string): boolean => {
  return excludedRoutes.some(route => matchPath(route, pathname));
};

export const isHcoOverviewPath = (pathname: string): boolean => isPathExcluded([AppRoutes.HCO_OVERVIEW], pathname);

const HCO_OVERVIEW_CONTENT_TAB_PARAM = 'overviewTab';
const HCO_EXECUTIVE_SUMMARY_TAB = 'executive-summary';

export const useIsFilterComponentVisible = (pathname: string, search = ''): boolean => {
  return useMemo(() => {
    if (isPathExcluded(EXCLUDE_FILTER_COMPONENT_ROUTES, pathname)) return false;
    if (isHcoOverviewPath(pathname)) {
      return new URLSearchParams(search).get(HCO_OVERVIEW_CONTENT_TAB_PARAM) !== HCO_EXECUTIVE_SUMMARY_TAB;
    }
    return true;
  }, [pathname, search]);
};

// On HCO Overview the date range only drives the Engagement tab widgets, so the bar is shown
// solely on that tab. The active tab lives in the URL as `?section=<tabId>` (a missing section
// defaults to the Overview tab), which the Header already reads via `useLocation`.
export const useIsDateRangeVisible = (pathname: string, search = ''): boolean => {
  return useMemo(() => {
    if (isPathExcluded(EXCLUDE_DATE_RANGE_ROUTES, pathname)) return false;
    if (isHcoOverviewPath(pathname)) {
      return new URLSearchParams(search).get('section') === HcoTabIndex.HCO_ENGAGEMENT;
    }
    return true;
  }, [pathname, search]);
};
